// Swatch King replacement, part 2 (Ella & Kate only).
//
// Swatch King didn't just paint swatches — it also relocated the Kiwi size chart up next
// to the Size option's label. Its own config had this baked in:
//   size_chart: { labels: "Size,Taille", position: "left",
//                 size_chart_app_selector: ".ks-chart-container, .ks-calculator-container..." }
// With the app disabled, Kiwi falls back to rendering as its own theme block *below* the
// variant picker, so this reproduces that relocation natively.
//
// Note on the selector: the element actually present in the page markup is Kiwi's own
// placeholder `<div class="ks-container-app-block">` — the .ks-chart-container /
// .ks-calculator-container elements from Swatch King's config are what Kiwi's async
// SizingPlugin builds *inside* that placeholder later. Moving the placeholder itself is
// therefore both earlier and more reliable; the others are kept as fallbacks in case a
// different Kiwi layout renders them standalone.
//
// Dawn replaces the whole <variant-selects> element on a variant change, which would strip
// the relocated node out again — hence the persistent observer rather than a one-shot move.
(function () {
  var OPTION_LABELS = ['size', 'taille'];
  var CHART_SELECTOR =
    '.ks-container-app-block, .ks-chart-container, .ks-calculator-container.sizing-calculator-container';

  function sizeLegend(root) {
    var fieldsets = root.querySelectorAll('fieldset[data-option-name]');
    for (var i = 0; i < fieldsets.length; i++) {
      var name = (fieldsets[i].dataset.optionName || '').toLowerCase().trim();
      if (OPTION_LABELS.indexOf(name) !== -1) {
        return fieldsets[i].querySelector('legend.form__label');
      }
    }
    return null;
  }

  function relocate(root) {
    var chart = document.querySelector(CHART_SELECTOR);
    if (!chart) return;

    var legend = sizeLegend(root);
    if (!legend) return;
    if (legend.contains(chart)) return; // already in place

    legend.classList.add('form__label--with-size-chart');
    legend.appendChild(chart);
  }

  document.querySelectorAll('product-info').forEach(function (productInfo) {
    relocate(productInfo);
    // Kiwi injects asynchronously, and Dawn re-renders the picker on every variant
    // change — so keep watching rather than moving once.
    new MutationObserver(function () {
      relocate(productInfo);
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
